import React, {Fragment} from "react";
import SFXLoadingComponent from "../SFXLoadingComponent";
import ChatConversationService from "../../services/chat/ChatConversationService";
import UserSessionService from "../../services/UserSessionService";
import ToastHelper from "../../utils/ToastHelper";
import SFXButtonComponent from "../SFXButtonComponent";
import {Col, Modal, ModalBody, Row} from "reactstrap";
import CreateChatComponent from "./CreateChatComponent";
import {withRouter} from "react-router";

const VIEWS = {
    NONE: 'NONE',
    NO_CONVERSATIONS: 'NO_CONVERSATIONS',
    ONLY_OPEN: 'ONLY_OPEN',
    ONLY_CLOSED: 'ONLY_CLOSED',
    OPEN_AND_CLOSED: 'OPEN_AND_CLOSED',
}

class ChatFromWithInContext extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resourceType: props.resourceType,
            resourceId: props.resourceId,
            loggedInUserId: UserSessionService.getUser().user.id,
            isLoading: false,
            gotConversations: false,
            gotOpenConversations: false,
            gotClosedConversations: false,
            isModalOpen: false,
            view: VIEWS.NONE,
            shouldShowCreate: false
        }
    }

    loadData() {
        this.setState({loading: true}, () => {
            ChatConversationService.retrieveAllForUserAndContext(this.state.loggedInUserId, this.state.resourceType, this.state.resourceId).then(
                response => {
                    let newState = {isLoading: false}
                    if (!Array.isArray(response)) {
                        ToastHelper.formatError(response)
                        return;
                    } else {
                        newState.gotConversations = true;
                        newState.openConversations = [];
                        newState.closedConversations = [];
                        response.forEach(conversation => {
                            if (conversation.status === 'OPEN') {
                                newState.openConversations.push(conversation);
                            } else {
                                newState.closedConversations.push(conversation);
                            }
                        })
                        newState.gotOpenConversations = newState.openConversations.length > 0;
                        newState.gotClosedConversations = newState.closedConversations.length > 0;

                        newState.isModalOpen = true;

                        if (!newState.gotConversations || (!newState.gotOpenConversations && !newState.gotClosedConversations)) {
                            newState.view = VIEWS.NO_CONVERSATIONS;
                        } else if (newState.gotOpenConversations && newState.gotClosedConversations) {
                            newState.view = VIEWS.OPEN_AND_CLOSED;
                        } else if (newState.gotOpenConversations) {
                            newState.view = VIEWS.OPEN_AND_CLOSED;
                        } else if (newState.gotClosedConversations) {
                            newState.view = VIEWS.ONLY_CLOSED;
                        }
                    }
                    this.setState(newState)
                }
            )
        })
    }

    toggleIsModalOpen() {
        this.setState({isModalOpen: !this.state.isModalOpen})
    };

    onChatClick() {
        this.loadData();
    }

    goToConversation(conversation) {
        this.props.history.push('/chat/' + conversation.id)
    }

    getContextUrlToAppend() {
        return '?rt=' + this.state.resourceType + '&ri=' + this.state.resourceId
    }

    goToOpenConversationsInContext() {
        this.props.history.push('/chat' + this.getContextUrlToAppend());
    }

    goToClosedInContext() {
        this.props.history.push('/chat/history' + this.getContextUrlToAppend());
    }

    render() {
        return <Fragment>
            <SFXButtonComponent
                color={'primary'}
                onClick={this.onChatClick.bind(this)}
            >
                Chat
            </SFXButtonComponent>

            <Modal
                toggle={this.toggleIsModalOpen.bind(this)}
                isOpen={this.state.isModalOpen}
            >
                <div style={{backgroundColor: "#222c3d", color: "white"}}>
                    {this.renderModalHeader()}
                </div>
                <ModalBody>
                    {this.renderModalBody()}
                </ModalBody>
            </Modal>
        </Fragment>
    }

    renderModalHeader() {
        return <Fragment>
            <div className={'modal-header'}>
                <div className={'modal-title'}>
                    <h5>Chat</h5>
                </div>
                <i className={"fa fa-times"}
                   style={{color: "white", fontWeight: "bold", float: 'right'}}
                   onClick={this.toggleIsModalOpen.bind(this)}
                />
            </div>
        </Fragment>
    }

    renderModalBody() {

        if (this.state.isLoading) {
            return <SFXLoadingComponent/>
        }

        switch (this.state.view) {
            case VIEWS.NO_CONVERSATIONS : {
                return <CreateChatComponent
                    context={[{resourceType: this.props.resourceType, resourceId: this.props.resourceId}]}
                />
            }
            case VIEWS.ONLY_CLOSED : {
                return <Fragment>
                    <Row>
                        <Col md={12}>
                            <SFXButtonComponent onClick={() => this.setState({shouldShowCreate: true})}
                                                color={'primary'}
                                                style={{width: '100%'}}
                            >
                                Start New Conversation
                            </SFXButtonComponent>
                        </Col>
                        <Col md={12}>
                            {this.renderViewHistoryButton()}
                        </Col>
                    </Row>
                    {
                        this.state.shouldShowCreate && <div style={{marginTop: 16}}>
                            <hr/>
                            <CreateChatComponent
                                style={{marginTop: 16}}
                                context={[{resourceType: this.props.resourceType, resourceId: this.props.resourceId}]}
                            />
                        </div>
                    }
                </Fragment>
            }
            case VIEWS.ONLY_OPEN : {
                if (this.state.openConversations.length === 1) {
                    this.goToConversation(this.state.openConversations[0])
                } else {
                    this.goToOpenConversationsInContext()
                }
                return <Fragment/>
            }
            case VIEWS.OPEN_AND_CLOSED : {
                let viewOpenFunction = () => {
                }
                if (this.state.openConversations.length === 1) {
                    viewOpenFunction = () => this.goToConversation(this.state.openConversations[0]);
                } else {
                    viewOpenFunction = () => this.goToOpenConversationsInContext();
                }

                return <Fragment>
                    <Row>
                        <Col md={12}>
                            <SFXButtonComponent onClick={() => viewOpenFunction()}
                                                color={'primary'}
                                                style={{width: '100%'}}
                            >
                                View Ongoing <span
                                style={{fontSize: '10pt'}}>({this.state.openConversations.length})</span>
                            </SFXButtonComponent>
                        </Col>
                        <Col md={12}>
                            {this.renderViewHistoryButton()}
                        </Col>
                    </Row>
                </Fragment>
            }
            case VIEWS.NONE:
            default : {
                return <Fragment>
                    Something went wrong please try refreshing your page
                </Fragment>
            }
        }
    }

    renderViewHistoryButton() {
        return <SFXButtonComponent onClick={this.goToClosedInContext.bind(this)}
                                   color={'primary'}
                                   style={{width: '100%', marginTop: 16}}
        >
            View History <span style={{fontSize: '10pt'}}>({this.state.closedConversations.length})</span>
        </SFXButtonComponent>
    }
}

export default withRouter(ChatFromWithInContext);